import { Form, Slider } from "antd";

export default function RenderRating(props) {
	const { namePath = [], form_question_options = [], required = false } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	let marks = {};
	let min = 0;
	let max = 5;

	// use the filtered array once so indexes/length are correct
	const options = form_question_options.filter((x) => !x.is_other);

	if (options.length) {
		options.forEach((option, index) => {
			// use numeric keys for marks
			const scale = Number(option.scale);
			marks[scale] = option.option;

			if (index === 0) {
				min = scale;
			}
			if (index === options.length - 1) {
				max = scale;
			}
		});
	}

	return (
		<Form.Item
			name={newNamePath}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<Slider marks={marks} step={0} min={min} max={max} />
		</Form.Item>
	);
}
